import {
  backfillExpressionIds,
  createLegacyExpressionIdGenerator,
  tableFilterExpressionsFromString,
  tableFilterExpressionsToString,
  type URLTableFilterExpression,
} from '@ardoq/table-filter-bar';
import { param } from './paramRegistry';

// Table filter bar expressions now require an id. Bookmarked legacy URLs
// don't have one, so backfill it here.
const filterExpressionsFromString = (
  value: string
): URLTableFilterExpression[] =>
  backfillExpressionIds(
    tableFilterExpressionsFromString(value),
    createLegacyExpressionIdGenerator()
  );

export const filterParam = param<URLTableFilterExpression[]>({
  fromString: filterExpressionsFromString,
  toString: tableFilterExpressionsToString,
});
